<template>
    <slot></slot>
</template>

<script src="./DateRangePicker"></script>
